export default "__VITE_ASSET__Bs3igrEB__"